import { render } from "./SongMetadata.vue?vue&type=template&id=a3fc3e52&scoped=true"
import script from "./SongMetadata.vue?vue&type=script&lang=js"
export * from "./SongMetadata.vue?vue&type=script&lang=js"

import "./SongMetadata.vue?vue&type=style&index=0&id=a3fc3e52&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3fc3e52"]])

export default __exports__